import { css } from '@emotion/core';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';

export const headline = css(typography.effra48, {
  fontWeight: fontWeights.medium,
  margin: '48px 0 0',
  verticalAlign: 'top',

  [MediaQueries.mdAndUp]: {
    marginTop: 64,
  },
});

export const backlink = css({
  marginTop: 16,
  [MediaQueries.mdAndUp]: {
    marginTop: 32,
  },
});

export const mainContainer = css({
  paddingBottom: 24,

  [MediaQueries.md]: {
    paddingBottom: 7,
  },

  [MediaQueries.lgAndUp]: {
    paddingBottom: 72,
  },
});

export const blocksContainer = {
  marginTop: 56,
};

export const blockItem = css({
  marginBottom: 40,

  [MediaQueries.mdAndUp]: {
    marginBottom: 88,
  },

  [MediaQueries.xl]: {
    marginBottom: 48,
  },
});

export const backToTop = css({
  bottom: 30,
  margin: '-63px 0 13px auto',
  position: 'sticky',
  width: 50,

  [MediaQueries.md]: {
    marginBottom: 23,
    marginTop: -73,
  },

  [MediaQueries.lgAndUp]: {
    bottom: 80,
    marginBottom: 8,
    marginTop: -58,
  },
});
